import { Component, OnDestroy, OnInit, Input, OnChanges, Output, EventEmitter, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { EMPTY, from, Subscription, Subject } from 'rxjs';
import { switchMap, debounceTime, tap, catchError, takeUntil, concatMap, finalize } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService, MenuItem } from 'primeng/api';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { Product, ProductInfo, ProductBatchInfo } from 'src/app/shared/product'
import { ProductGroup } from 'src/app/shared/product-group'

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';
import { RestApiService } from 'src/app/services/rest-api.service';

export interface Column {
  field: string;
  header: string;
  nonhide: boolean;
  show: boolean;
  filter: boolean;
}

@Component({
  selector: 'app-list-product-array',
  templateUrl: './list-product-array.component.html',
  styleUrls: ['./list-product-array.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListProductArrayComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  columns: Column[] = [
    { field: 'PRODCODE', header: 'Код товара', nonhide: true, show: true, filter: true },
    { field: 'PRODARTICUL', header: 'Артикул', nonhide: false, show: false, filter: true },
    { field: 'PRODCUSTCODE', header: 'Код УКТЗЕД', nonhide: false, show: false, filter: true },
    { field: 'PRODNAME', header: 'Наименование товара', nonhide: false, show: true, filter: true },
    { field: 'PRODDESCRIPTION', header: 'Описание товара', nonhide: false, show: false, filter: true },
    { field: 'PRODNOTE', header: 'Примечание', nonhide: false, show: false, filter: true },
    { field: 'PRODGROUPNAME', header: 'Группа', nonhide: false, show: false, filter: true },
    { field: 'PRODVENDORNAME', header: 'Производитель', nonhide: false, show: false, filter: true },
    { field: 'PRODPRICEUAH', header: 'Цена', nonhide: true, show: true, filter: true },
    { field: 'PRODPRICEUSD', header: 'В валюте', nonhide: false, show: true, filter: true },
    { field: 'PRODSTOCK', header: 'Склад', nonhide: false, show: true, filter: true },
    { field: 'PRODPRICEUAH2', header: 'Цена 2', nonhide: false, show: false, filter: true },
    { field: 'PRODPRICEUSD2', header: 'В валюте 2', nonhide: false, show: false, filter: true },
  ];

  public get visiblePRODCODEColumn(): boolean { return this._visibleColumn('PRODCODE') }
  public get visiblePRODARTICULColumn(): boolean { return this._visibleColumn('PRODARTICUL') }
  public get visiblePRODCUSTCODEColumn(): boolean { return this._visibleColumn('PRODCUSTCODE') }
  public get visiblePRODNAMEColumn(): boolean { return this._visibleColumn('PRODNAME') }
  public get visiblePRODDESCRIPTIONColumn(): boolean { return this._visibleColumn('PRODDESCRIPTION') }
  public get visiblePRODNOTEColumn(): boolean { return this._visibleColumn('PRODNOTE') }
  public get visiblePRODGROUPNAMEColumn(): boolean { return this._visibleColumn('PRODGROUPNAME') }
  public get visiblePRODVENDORNAMEColumn(): boolean { return this._visibleColumn('PRODVENDORNAME') }
  public get visiblePRODPRICEUAHColumn(): boolean { return this._visibleColumn('PRODPRICEUAH') }
  public get visiblePRODPRICEUSDColumn(): boolean { return this._visibleColumn('PRODPRICEUSD') }
  public get visiblePRODPRICEUAH2Column(): boolean { return this._visibleColumn('PRODPRICEUAH2') }
  public get visiblePRODPRICEUSD2Column(): boolean { return this._visibleColumn('PRODPRICEUSD2') }
  public get visiblePRODSTOCKColumn(): boolean { return this._visibleColumn('PRODSTOCK') }

  private _visibleColumn(name: string): boolean {
    const col: Column = this.selectedColumns.find(e => e.field == name);
    //console.log('*** ListProductArrayComponent _visibleColumn ' + name + ' (selection): ' + JSON.stringify(col));
    return (col) ? true : false;
  }

  public get filterPRODCODEColumn(): boolean { return this._filterColumn('PRODCODE') }
  public get filterPRODARTICULColumn(): boolean { return this._filterColumn('PRODARTICUL') }
  public get filterPRODCUSTCODEColumn(): boolean { return this._filterColumn('PRODCUSTCODE') }
  public get filterPRODNAMEColumn(): boolean { return this._filterColumn('PRODNAME') }
  public get filterPRODDESCRIPTIONColumn(): boolean { return this._filterColumn('PRODDESCRIPTION') }
  public get filterPRODNOTEColumn(): boolean { return this._filterColumn('PRODNOTE') }
  public get filterPRODGROUPNAMEColumn(): boolean { return this._filterColumn('PRODGROUPNAME') }
  public get filterPRODVENDORNAMEColumn(): boolean { return this._filterColumn('PRODVENDORNAME') }
  public get filterPRODPRICEUAHColumn(): boolean { return this._filterColumn('PRODPRICEUAH') }
  public get filterPRODPRICEUSDColumn(): boolean { return this._filterColumn('PRODPRICEUSD') }
  public get filterPRODPRICEUAH2Column(): boolean { return this._filterColumn('PRODPRICEUAH2') }
  public get filterPRODPRICEUSD2Column(): boolean { return this._filterColumn('PRODPRICEUSD2') }
  public get filterPRODSTOCKColumn(): boolean { return this._filterColumn('PRODSTOCK') }

  private _filterColumn(name: string): boolean {
    const col: Column = this.columns.find(e => e.field == name);
    return (col) ? col.filter : false;
  }

  public get columnCount(): string {

    //    let cols: number = 2;
    //    this.selectedColumns.forEach(e => { if (e.show) ++cols; });

    let cols = (this.prodTable.columns.length + 2).toFixed(0);
    console.log('*** ListProductArrayComponent get columnCount: ' + cols);

    return cols;
  }

  public columnCounter(): number {

    return (this.prodTable && 'columns' in this.prodTable && this.prodTable.columns) ? this.prodTable.columns.length + 2 : 7;;
  }

  @Input() uahCurrencyId: number = 102;
  @Input() usdCurrencyId: number = 105;

  @Input() showCaption: boolean = true;

  @Input() showToolBar: boolean = true;

  @Input() showUSDCurrencySelector: boolean = true;

  @Input() showObsoleteProducts: number[] = [0,2];

  showProductOptions = [
    { name: 'Актуальные', value: 0 },
    { name: 'Устаревшие', value: 1 },
    { name: 'Сборные', value: 2 },
  ];

  @Input() initialColumnSet: string[] = [
    'PRODCODE',
    'PRODNAME',
    //'PRODDESCRIPTION',
    //'PRODNOTE',
    'PRODPRICEUAH',
    'PRODPRICEUSD',
    //'PRODPRICEUAH2',
    //'PRODPRICEUSD2',
    'PRODSTOCK'
  ];

  @Input() products: Product[];

  @Input() showFilterHeader: boolean = true;

  @Input()
            get selectedColumns(): Column[] {
              return this._selectedColumns;
            }
            set selectedColumns(val: Column[]) {
              this._selectedColumns = [...val];
            }
            _selectedColumns: Column[] = [];

  @Input() showColumnSelector: boolean = false;

  @Input() state: string = 'product-array-state';
  @Input() noData: string = "Нет данных для загрузки";

  @Input() rows: number = 20;   /* for flex scroll */
  totalRecords: number;
  @Input() loading: boolean = false;

  productList: Product[] = [];
  @ViewChild('prodTable') prodTable: Table;

  selectedProduct: Product[] = [];
  currentSelectedProduct: Product;     // single Selection mode

  public get noSelection(): boolean { return !(this.selectedProduct && this.selectedProduct.length > 0); }

  items: MenuItem[] = [
    {
      label: 'Устаревший...', icon: 'pi pi-ban', command: () => {
        this.doObsoleteProduct();
      }
    },
    {
      label: 'Переместить в...', icon: 'pi pi-site-map', command: () => {
        this.doMoveProduct();
      }
    },
    {
      label: 'Прозводитель...', icon: 'pi pi-user-edit', command: () => {
        this.doChangeVendorProduct();
      }
    },
    {
      label: 'Категория...', icon: 'pi pi-user-edit', command: () => {
        this.doChangeCategoryProduct();
      }
    },
    {
      label: 'Таможенный код ...', icon: 'pi pi-user-edit', command: () => {
        this.enterCodeString();
      }
    },
  ];

  tableHeader: string = '';

  prodCodeFilter: string;
  prodArticulFilter: string;
  prodNameFilter: string;
  prodDescFilter: string;
  prodNoteFilter: string;
  prodGroupFilter: string;
  prodVendorFilter: string;

  custCodeFilter: string;

  prodPriceUahFilter: number;
  prodPriceUsdFilter: number;
  prodPriceUah2Filter: number;
  prodPriceUsd2Filter: number;
  prodStockBeFilter: number;

  filters: any;

  private _prodListQuery: Subscription;
  private readonly destroy$ = new Subject<void>();

  private listOptions$ = new Subject<{ products: Product[], obsolete: number[], balCurr: number, filter: any }>();

  excelExportItems: MenuItem[] = [
    {
      label: 'С логистикой', icon: 'pi pi-star-o', disabled: false, command: () => {
        this.onExportDataWithLogistic();
      }
    },
    {
      label: 'Подробное', icon: 'pi pi-star-o', disabled: false, command: () => {
        this.onExportDataWithExtendedInfo();
      }
    },
  ];

  contentReady: boolean = false;

  @Output() listIsReady = new EventEmitter<boolean>();
  @Output() productSelected = new EventEmitter<Product>();

  private _prodGrEditQuery: Subscription;

  displayGG: boolean = false;

  groupId: number = null;

  displaySC: boolean = false;
  codeString: string = '';

  displayGS: boolean = false;
  confirmMarkProdObsDisplay: boolean = false;
  confirmMarkProdObsConfirmation: boolean = false;

  confirmMarkProdObsText: string = 'MOVE';
  confirmMarkProdObsMessage: string = 'Отметить выбранные товары устаревшими?';
  confirmMarkProdObsHeader: string = 'Подтверждение действия с несколькими товарами';

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private filterService: FilterService,
    private restapi: RestApiService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ListProductArrayComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (const propName of Object.keys(changes)) {
      const change = changes[propName];

      environment.production || console.log('*** ListProductArrayComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ListProductArrayComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'products':
        case 'showObsoleteProducts':
        case 'uahCurrencyId':
        case 'usdCurrencyId':
          this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
          break;

        case 'state':
          //environment.production || console.table(this.columns);
          //environment.production || console.log('*** ListProductArrayComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

          //if (this.state != '') {
          //  let storedColumns: string = localStorage.getItem(this.state + '-columns');
          //  if (storedColumns) {
          //    //console.log('*** ListProductArrayComponent in ngOnInit: restore storedColumns')
          //    this.selectedColumns = JSON.parse(storedColumns);
          //  } else {
          //    //console.log('*** ListProductArrayComponent in ngOnInit: restore default storedColumns')

          //  }

          //  let showObsoleted: string = localStorage.getItem(this.state + '-obsoleted');
          //  console.log('*** ListProductArrayComponent in ngOnInit: restore showObsoleted: ' + showObsoleted);
          //  if (showObsoleted) {
          //    this.showObsoleteProducts = JSON.parse(showObsoleted);
          //  }
          //}
          break;

        case 'initialColumnSet':
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ListProductArrayComponent in ngOnDestroy');

    if (this.state != '') {
      localStorage.setItem(this.state + '-columns', JSON.stringify(this.selectedColumns));
      localStorage.setItem(this.state + '-obsoleted', JSON.stringify(this.showObsoleteProducts));
    }

    this.destroy$.next();
    this.destroy$.complete();

    if (this._prodGrEditQuery) { this._prodGrEditQuery.unsubscribe(); }
  }

  createProductSubscription() {

    this._prodListQuery =
      this.listOptions$.pipe(
        takeUntil(this.destroy$),
        debounceTime(200),

        tap(() => {
          this.loading = true;
          this.contentReady = false;
          this.listIsReady.emit(false);
        }),

        switchMap(options => {
          if (!options.products?.length) {
            this.productList = [];
            this.totalRecords = 0;
            this.loading = false;
            this.contentReady = true;
            this.listIsReady.emit(true);
            return EMPTY;
          }

          // Apply obsolete / kind filter in memory — no HTTP needed
          this.productList = options.products.filter(p => {
            if ([0, this.showProductOptions.length].includes(options.obsolete.length)) return true;
            if (options.obsolete.includes(1) && p.PRODOBSOLETE == 1) return true;
            if (options.obsolete.includes(0) && p.PRODOBSOLETE == 0) return true;
            if (options.obsolete.includes(2) && p.PRODKIND == 1) return true;
            return false;
          });
          this.totalRecords = this.productList.length;

          const ids = this.productList.map(p => p.PRODID).filter(id => id > 0);

          // Nothing to enrich (e.g. import result made up entirely of not-yet-saved
          // products, PRODID -2) — /Product/BatchInfo 400s on an empty prodIds array,
          // so skip the round-trip instead of firing a guaranteed-failing request.
          if (ids.length === 0) {
            this.loading = false;
            this.contentReady = true;
            this.listIsReady.emit(true);
            return EMPTY;
          }

          // One currency fetch for the display rate
          return this.restapi.getCurrencyInfoByID(options.balCurr, new Date()).pipe(
            switchMap(currencies => {
              const currency = currencies?.[0];
              if (!currency) {
                this.loading = false;
                this.contentReady = true;
                this.listIsReady.emit(true);
                return EMPTY;
              }

              environment.production || console.log('*** ListProductArrayComponent getCurrencyInfoByID emitted: ' + JSON.stringify(currency));

              // One batch call for all enrichment data
              return this.prodApi.getProdInfoBatch(
                ids,
                this.globalSettinsData.mainCompanyId,
                this.uahCurrencyId,
                currency.CURID,
                this.globalSettinsData.mainStockId,
                this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
                this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
                new Date()
              ).pipe(
                tap((batchData: ProductBatchInfo[]) => {
                  const infoMap = new Map(batchData.map(b => [b.PRODID, b]));
                  this.productList.forEach(p => {
                    const info = infoMap.get(p.PRODID);
                    if (!info) return;
                    p.PRODSTOCK      = info.PRODSTOCK;
                    p.PRODPRICEUAH   = info.PRODPRICEUAH;
                    p.PRODPRICEUSD   = info.PRODPRICEUSD;
                    p.PRODVENDORNAME = info.PRODVENDORNAME;
                    p.PRODGROUPNAME  = info.PRODGROUPNAME;
                    p.CURRENCYRATE   = currency.CURRATE;
                    if (!p._PRODUCTINFO) { p._PRODUCTINFO = new ProductInfo(); }
                    p._PRODUCTINFO.VENDORCURRID  = info.VENDORCURRID;
                    p._PRODUCTINFO.VENDORCURCODE = info.VENDORCURCODE;
                    p._PRODUCTINFO.PRODSTOCK     = info.PRODSTOCK;
                    // Discount tiers
                    p._PRODUCTINFO.PRODBASEDISC  = info.PRODBASEDISC;
                    p._PRODUCTINFO.PRODQTYDISC   = info.PRODQTYDISC;
                    p._PRODUCTINFO.PRODDIALDISC  = info.PRODDIALDISC;
                    // Disc-applied prices (foreign currency)
                    p._PRODUCTINFO.BASEDISCPRICE = info.PRODPRICEUSD * (1 - info.PRODBASEDISC / 100);
                    p._PRODUCTINFO.QTYDISCPRICE  = info.PRODPRICEUSD * (1 - info.PRODQTYDISC  / 100);
                    p._PRODUCTINFO.DIALDISCPRICE = info.PRODPRICEUSD * (1 - info.PRODDIALDISC / 100);
                  });
                  this.loading = false;
                  this.contentReady = true;
                  this.listIsReady.emit(true);
                }),
                catchError(err => {
                  console.error('*** ListProductArrayComponent getProdInfoBatch error: ', err);
                  this.loading = false;
                  this.contentReady = true;
                  this.listIsReady.emit(true);
                  return EMPTY;
                })
              );
            }),
            catchError(err => {
              console.error('*** ListProductArrayComponent getCurrencyInfoByID error: ', err);
              this.loading = false;
              this.contentReady = true;
              this.listIsReady.emit(true);
              return EMPTY;
            })
          );
        })

      ).subscribe({
        error: err => {
          console.error('*** ListProductArrayComponent listOptions$ error: ', err);
          this.contentReady = true;
          this.listIsReady.emit(true);
        }
      });
  }

  onRowExpand(event: { data: Product }): void {
    const p = event.data;
    if (p._PRODVENDORS) return;
    this.prodApi.getProdVendors(p.PRODID).pipe(
      takeUntil(this.destroy$),
      catchError(err => {
        console.error('*** ListProductArrayComponent getProdVendors error: ', err);
        return EMPTY;
      })
    ).subscribe(data => { p._PRODVENDORS = data; });
  }

  ngOnInit(): void {
    console.log('*** ListProductArrayComponent in ngOnInit');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.columns.forEach(e => {
      e.show = e.nonhide ? true : (this.initialColumnSet.findIndex(n => n == e.field) > -1);
    })
    this.selectedColumns = this.columns.filter(e => e.show);

    //if (this.state != '') {
    //  let storedColumns: string = localStorage.getItem(this.state + '-columns');
    //  if (storedColumns) {
    //    //console.log('*** ListProductArrayComponent in ngOnInit: restore storedColumns')
    //    this.selectedColumns = JSON.parse(storedColumns);
    //  } else {
    //    //console.log('*** ListProductArrayComponent in ngOnInit: restore default storedColumns')

    //  }

    //  let showObsoleted: string = localStorage.getItem(this.state + '-obsoleted');
    //  console.log('*** ListProductArrayComponent in ngOnInit: restore showObsoleted: ' + showObsoleted);
    //  if (showObsoleted) {
    //    this.showObsoleteProducts = JSON.parse(showObsoleted);
    //  }
    //}

    this.createProductSubscription();

    this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
  }

  onCurrencyChange(event) {
    console.log('*** ListProductArrayComponent onCurrencyChange: ' + JSON.stringify(event));

    if (event && ('CURID' in event)) {
      this.usdCurrencyId = event.CURID;
      this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
    }
  }

  clearSelection(event) {
    console.log('*** ListProductArrayComponent clearSelection ');
    this.selectedProduct = [];
  }

  onHeaderCheckboxToggle(event) {
    console.log('*** ListProductArrayComponent onHeaderCheckboxToggle ' + JSON.stringify(event));
  }

  onStateSave(state) {
    //    console.log('*** ListProductArrayComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestore(state) {
    environment.production || console.log('*** ListProductArrayComponent onStateRestore: ' + JSON.stringify(state));

    if (state.filters) {
      this.filters = state.filters;

      for (let f in state.filters) {
        let fltItem = state.filters[f];
        let fltValue = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;

        switch (f) {

          case 'PRODCODE': this.prodCodeFilter = fltValue; break;

          case 'PRODCUSTCODE': this.custCodeFilter = fltValue; break;

          case 'PRODNAME': this.prodNameFilter = fltValue; break;

          case 'PRODDESCRIPTION': this.prodDescFilter = fltValue; break;

          case 'PRODNOTE': this.prodNoteFilter = fltValue; break;

          case 'PRODGROUPNAME': this.prodGroupFilter = fltValue; break;

          case 'PRODVEBDORNAME': this.prodGroupFilter = fltValue; break;

          case 'PRODPRICEUAH': this.prodPriceUahFilter = fltValue; break;

          case 'PRODPRICEUSD': this.prodPriceUsd2Filter = fltValue; break;

          case 'PRODPRICEUAH2': this.prodPriceUahFilter = fltValue; break;

          case 'PRODPRICEUSD2': this.prodPriceUsd2Filter = fltValue; break;

          case 'PRODSTOCK': this.prodStockBeFilter = fltValue; break;

          case 'global':
            //            this.documentGlobalFilter = fltValue;
            break;

          default:
            console.log(JSON.stringify(f));
        }
      }
    }
    if (state.selection) {
      this.selectedProduct = state.selection;
    }
  }

  clearOrResetTableFilter(event) {
    console.log('*** ListProductArrayComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    //    this.prodTable.filters = [];

    this.selectedProduct = [];
    this.filters = null;
    this.showObsoleteProducts = [];

    this.prodCodeFilter =
      this.prodNameFilter =
      this.prodDescFilter =
      this.prodNoteFilter =
      this.prodGroupFilter =
      this.prodVendorFilter =
      this.custCodeFilter = '';

    this.prodPriceUahFilter =
      this.prodPriceUsdFilter =
      this.prodStockBeFilter = null;

    this.prodTable.clearState();
    this.prodTable.clear();
    this.prodTable.reset();

    this.prodTable.filters = {};

    this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
  }

  onObsoleteOptionChange(event) {
    console.log('*** ListProductArrayComponent onObsoleteOptionChange: ' + JSON.stringify(event));
    localStorage.setItem(this.state + '-obsoleted', JSON.stringify(this.showObsoleteProducts));

    this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
  }

  reloadTable(event) {
    console.log('*** ListProductArrayComponent reloadTable: ' + JSON.stringify(event));

    this.listOptions$.next({ products: [... this.products], obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
  }

  onRowSelect(event) {
    console.log('*** ListProductArrayComponent onRowSelect: ' + JSON.stringify(event.data));
    this.currentSelectedProduct = event;
    this.productSelected.emit(this.currentSelectedProduct);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** HomeNotShippedOrdersListComponent onExportData: ')

    import("xlsx").then(xlsx => {

//      environment.production || console.table(this.products);

      const exportData: any =

        (((this.selectedProduct || []).length > 0) ? this.selectedProduct : this.products)

          .map(e => ({
        

          'Код': e.PRODCODE,
          'Название': e.PRODNAME,
          'Описание': e.PRODDESCRIPTION,
          'Дополнительно': e.PRODNOTE,
          'Группа': e.PRODGROUPNAME,
          'Код УКТЗЕД': e.PRODCUSTCODE,
          'Производитель': e.PRODVENDORNAME,
          'Цена': e.PRODPRICEUAH,
          'Цена в валюте': e.PRODPRICEUSD,

          'Ссылка': e.PRODWWWPAGE,

          'Наличие на складе': e.PRODSTOCK,
          'Продано': e.PRODSOLD,
          'В резерве': e.PRODRESERV,
          'В пути': e.PRODONHAND,

          'Цена 2': e.PRODPRICEUAH2,
          'Цена в валюте 2': e.PRODPRICEUSD2,

          'Минимальная скидка': e._PRODUCTINFO ? e.PRODBASEDISC : null,
          'Средняя скидка': e._PRODUCTINFO ? e.PRODQTYDISC : null,
          'Максимальная скидка': e._PRODUCTINFO ? e.PRODDIALDISC : null,
          'Цена с мин скидкой': e._PRODUCTINFO ? e._PRODUCTINFO.BASEDISCPRICE : null,
          'Цена со средней скидкой': e._PRODUCTINFO ? e._PRODUCTINFO.QTYDISCPRICE : null,
          'Цена с макс скидкой': e._PRODUCTINFO ? e._PRODUCTINFO.DIALDISCPRICE : null,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { products: worksheet }, SheetNames: ['products'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "products");
    });
  }

  checkCommand(event) {
    this.excelExportItems.forEach(e => e.disabled = !this.contentReady);
  }

  onExportDataWithLogistic() {
    import("xlsx").then(xlsx => {

      let exportData: any =
        (((this.selectedProduct || []).length > 0) ? this.selectedProduct : this.products).map(e => ({

          'Код товара': e.PRODCODE,
          'Наименование товара': e.PRODNAME,
          'Описание': e.PRODDESCRIPTION,
          'Цена с НДС': e.PRODPRICEUAH,
          'Цена в валюте': e.PRODPRICEUSD,
          'Скидка 1': e.PRODBASEDISC,
          'Скидка 2': e.PRODQTYDISC,
          'Скидка 3': e.PRODDIALDISC,

          'Ставка НДС': e.PRODVAT,
          'Таможенный код': e.PRODCUSTCODE,
          'Вес': e.PRODWEIGHT,
          'Срок поставки': e.PRODDELTERM,

          'Группа': e.PRODGROUPNAME,
          'Производитель': e.PRODVENDORNAME,

          'Склад': e.PRODSTOCK,
          'В резерве': e._PRODUCTINFO.PRODRESERVE,
          'Продано': e._PRODUCTINFO.PRODSOLD,
          'В пути': e._PRODUCTINFO.PRODONWAY,

          'Поставщик': e._PRODUCTINFO.VENDORNAME,
          'Цена поставщика': e._PRODUCTINFO.VENDORPRICE,
          'Доставка': e._PRODUCTINFO.VENADDCONST,
          'Пошлина': e._PRODUCTINFO.VENMULCONST,
          'Дополнительно +': e._PRODUCTINFO.VENADDVAR,
          'Дополнительно *': e._PRODUCTINFO.VENMULVAR,
          'Маржа': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VENDORMARGIN,
          'Округление': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VENROUNDBASE,
          'Старый расчет входной цены': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VPINCOMPRICEXPR,
          'Старый расчет выходной цены': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).EUPRICEEXPR,
          'Примечание': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VENDORNOTE,
        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { products: worksheet }, SheetNames: ["products"] };

      //environment.production || console.table(this.selectedProductList);

      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      console.log('*** ProductsComponent exportExcel: ' + JSON.stringify(excelBuffer));

      this.saveAsExcelFile(excelBuffer, "products");
    });
  }

  onExportDataWithExtendedInfo() {
    import("xlsx").then(xlsx => {

      let exportData: any =
        (((this.selectedProduct || []).length > 0) ? this.selectedProduct : this.products).map(e => ({

          'Код товара': e.PRODCODE,
          'Артикул': e.PRODARTICUL,
          'Штрихкод': e.PRODBARCODEMASK,
          'Наименование товара': e.PRODNAME,
          'Описание': e.PRODDESCRIPTION,
          'Для бухгалтерии': e.PRODNOTE,
          'Цена с НДС': e.PRODPRICEUAH,
          'Цена в валюте': e.PRODPRICEUSD,
          'Скидка 1': e.PRODBASEDISC,
          'Скидка 2': e.PRODQTYDISC,
          'Скидка 3': e.PRODDIALDISC,

          'Ставка НДС': e.PRODVAT,
          'Таможенный код': e.PRODCUSTCODE,
          'Вес': e.PRODWEIGHT,

          'В упаковке': e.PRODPACK,
          'Вес упаковки': e.PRODPACKGW,
          'Объем упаковки': e.PRODPACKVOL,
          'Гарантия': e.PRODWARRANTY,
          'Срок поставки': e.PRODDELTERM,

          'Группа': e.PRODGROUPNAME,
          'Производитель': e.PRODVENDORNAME,

          'Склад': e.PRODSTOCK,
          'В резерве': e._PRODUCTINFO.PRODRESERVE,
          'Продано': e._PRODUCTINFO.PRODSOLD,
          'В пути': e._PRODUCTINFO.PRODONWAY,

          'Поставщик': e._PRODUCTINFO.VENDORNAME,
          'Цена поставщика': e._PRODUCTINFO.VENDORPRICE,
          'Валюта поставщика': e._PRODUCTINFO.VENDORCURCODE,

          'Доставка': e._PRODUCTINFO.VENADDCONST,
          'Пошлина': e._PRODUCTINFO.VENMULCONST,
          'Дополнительно +': e._PRODUCTINFO.VENADDVAR,
          'Дополнительно *': e._PRODUCTINFO.VENMULVAR,
          'Маржа': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VENDORMARGIN,
          'Округление': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VENROUNDBASE,
          'Старый расчет входной цены': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VPINCOMPRICEXPR,
          'Старый расчет выходной цены': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).EUPRICEEXPR,
          'Примечание': e._PRODVENDORS.find(v => (v.VENDORSITEMID == e.PRODPRICEVID)).VENDORNOTE,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { products: worksheet }, SheetNames: ["products"] };

      //environment.production || console.table(this.selectedProductList);

      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      console.log('*** ProductsComponent exportExcel: ' + JSON.stringify(excelBuffer));

      this.saveAsExcelFile(excelBuffer, "products");
    });
  }

  onMarkProdObsConfirmation(event) {
    console.log('*** ProductListComponent onMarkProdObsConfirmation ');

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        concatMap(sp => this.prodApi.putProductMainInfo({ ...sp, PRODOBSOLETE: 1 })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
          console.log('*** ProductListComponent onMarkProdObsConfirmation - in the end');
        })

      ).subscribe();
  }

  doObsoleteProduct() {
    console.log('*** ProductListComponent doObsoleteProduct ');

    //environment.production || console.table(this.selectedProduct);

    this.confirmMarkProdObsDisplay = true;
  }

  onSelectedGroup(event: ProductGroup) {
    console.log('*** ProductListComponent onSelectedGroup ');

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        concatMap(sp => this.prodApi.putProductMainInfo({ ...sp, PRODGROUP: event.PGROUPID })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
          console.log('*** ProductListComponent onSelectedGroup - in the end');
        })

      ).subscribe();
  }

  doMoveProduct() {
    console.log('*** ProductListComponent doMoveProduct ');

    this.displayGS = true;
  }

  doChangeVendorProduct() {
    console.log('*** ProductListComponent doChangeVendorProduct ');

  }

  onSelectProductCategory(event) {
    console.log('*** ProductListComponent onSelectProductCategory ' + JSON.stringify(event));

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        concatMap(sp => this.prodApi.putProductCategoryByID({ ...sp, PRODCATEGORY: event })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
          console.log('*** ProductListComponent onSelectProductCategory - in the end');
        })

      ).subscribe();
  }

  doChangeCategoryProduct() {
    console.log('*** ProductListComponent doChangeCategoryProduct ');

    this.displayGG = true;
  }

  enterCodeString() {
    console.log('*** ProductListComponent enterCodeString ');

    this.displaySC = true;
  }

  onEnterCodeString(event) {
    console.log('*** ProductListComponent onEnterCodeString ' + JSON.stringify(event));

    this.loading = true;
    this._prodGrEditQuery =

      from(this.selectedProduct).pipe(

        concatMap(sp => this.prodApi.putProductMainInfo({ ...sp, PRODCUSTCODE: event })),

        finalize(() => {
          this.selectedProduct = [];
          this.listOptions$.next({ products: this.products, obsolete: this.showObsoleteProducts, balCurr: this.usdCurrencyId, filter: this.filters });
          console.log('*** ProductListComponent onEnterCodeString - in the end');
        })

      ).subscribe();
  }
}
